import Header from '../components/Header';
import Footer from '../components/Footer';
import { Cookie, Settings } from 'lucide-react';

const Cookies = () => {
  return (
    <div className="min-h-screen bg-dark-bg">
      <Header />
      <main className="py-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <article className="bg-dark-card border-2 border-gray-800 rounded-2xl p-8 md:p-12">
            <div className="flex items-center mb-6">
              <Cookie className="w-8 h-8 text-toxic-green mr-4" />
              <h1 className="text-4xl md:text-5xl font-bold text-white">
                Politique des Cookies
              </h1>
            </div>

            <div className="prose prose-invert max-w-none">
              <p className="text-gray-400 mb-8 text-sm">
                Dernière mise à jour : 26 novembre 2025
              </p>

              <p className="text-gray-300 mb-6 leading-relaxed">
                Cette Politique des Cookies explique ce que sont les cookies, comment nous les utilisons sur notre site web hexabetconnect.com, et comment vous pouvez contrôler leur utilisation. En utilisant notre Site, vous acceptez l'utilisation de cookies conformément à cette politique.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                1. Qu'est-ce qu'un Cookie ?
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Un cookie est un petit fichier texte qui est stocké sur votre appareil (ordinateur, tablette, smartphone) lorsque vous visitez un site web. Les cookies permettent au site de reconnaître votre appareil et de mémoriser certaines informations sur vos préférences ou vos actions passées.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Les cookies peuvent être "persistants" (ils restent sur votre appareil jusqu'à leur expiration ou leur suppression) ou "de session" (ils sont supprimés lorsque vous fermez votre navigateur).
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                2. Types de Cookies que Nous Utilisons
              </h2>
              <h3 className="text-2xl font-bold mt-8 mb-4 text-white">
                Cookies Strictement Nécessaires
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Ces cookies sont essentiels au fonctionnement du Site et ne peuvent pas être désactivés. Ils sont généralement définis en réponse à des actions que vous effectuez et qui équivalent à une demande de services, comme définir vos préférences de confidentialité, vous connecter ou remplir des formulaires.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Ces cookies ne stockent pas d'informations personnellement identifiables. Sans ces cookies, certains services que vous demandez ne peuvent pas être fournis.
              </p>

              <h3 className="text-2xl font-bold mt-8 mb-4 text-white">
                Cookies de Performance et d'Analyse
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Ces cookies nous permettent de compter les visites et les sources de trafic afin d'améliorer les performances de notre Site. Ils nous aident à savoir quelles pages sont les plus et les moins populaires et à voir comment les visiteurs se déplacent sur le Site.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Toutes les informations que ces cookies collectent sont agrégées et donc anonymes. Si vous n'autorisez pas ces cookies, nous ne saurons pas quand vous avez visité notre Site et ne pourrons pas surveiller ses performances.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Nous utilisons notamment Google Analytics pour analyser l'utilisation de notre Site. Google Analytics utilise des cookies pour collecter des informations sur votre utilisation du Site. Ces informations sont transmises à Google et stockées sur ses serveurs. Vous pouvez refuser l'utilisation de cookies Google Analytics en installant le module complémentaire de désactivation du navigateur Google Analytics.
              </p>

              <h3 className="text-2xl font-bold mt-8 mb-4 text-white">
                Cookies de Fonctionnalité
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Ces cookies permettent au Site de fournir des fonctionnalités et une personnalisation améliorées. Ils peuvent être définis par nous ou par des fournisseurs tiers dont nous avons ajouté les services à nos pages.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Si vous n'autorisez pas ces cookies, certains ou tous ces services peuvent ne pas fonctionner correctement.
              </p>

              <h3 className="text-2xl font-bold mt-8 mb-4 text-white">
                Cookies de Ciblage et de Publicité
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Ces cookies peuvent être définis sur notre Site par nos partenaires publicitaires. Ils peuvent être utilisés par ces entreprises pour créer un profil de vos intérêts et vous montrer des publicités pertinentes sur d'autres sites.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Ils ne stockent pas directement des informations personnelles, mais sont basés sur l'identification unique de votre navigateur et de votre appareil Internet. Si vous n'autorisez pas ces cookies, vous recevrez des publicités moins ciblées.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                3. Cookies Tiers
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                En plus de nos propres cookies, nous pouvons également utiliser divers cookies tiers pour nous aider à analyser l'utilisation du Site, à fournir des fonctionnalités de médias sociaux, et à diffuser des publicités.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Ces cookies tiers sont définis par des domaines autres que le nôtre. Nous n'avons pas accès à ces cookies et les tiers n'ont pas accès aux nôtres. Les tiers peuvent utiliser leurs propres cookies pour collecter des informations sur vos activités en ligne.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                4. Durée de Conservation des Cookies
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                La durée de conservation des cookies varie selon leur type :
              </p>
              <ul className="list-disc list-inside space-y-3 text-gray-300 mb-6 ml-4">
                <li><strong>Cookies de session :</strong> Supprimés automatiquement lorsque vous fermez votre navigateur</li>
                <li><strong>Cookies persistants :</strong> Restent sur votre appareil pendant une période déterminée ou jusqu'à ce que vous les supprimiez manuellement</li>
                <li><strong>Cookies de première partie :</strong> Généralement conservés entre 1 et 24 mois</li>
                <li><strong>Cookies tiers :</strong> Durées variables selon les fournisseurs tiers</li>
              </ul>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                5. Comment Gérer les Cookies
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Vous avez le contrôle sur les cookies. La plupart des navigateurs acceptent automatiquement les cookies, mais vous pouvez généralement modifier les paramètres de votre navigateur pour refuser les cookies si vous le préférez.
              </p>
              <h3 className="text-2xl font-bold mt-8 mb-4 text-white">
                Paramètres du Navigateur
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Vous pouvez configurer votre navigateur pour qu'il vous avertisse lorsque des cookies sont envoyés ou pour qu'il refuse tous les cookies. Voici comment procéder pour les navigateurs les plus courants :
              </p>
              <ul className="list-disc list-inside space-y-3 text-gray-300 mb-6 ml-4">
                <li><strong>Google Chrome :</strong> Paramètres > Confidentialité et sécurité > Cookies et autres données de sites</li>
                <li><strong>Mozilla Firefox :</strong> Options > Vie privée et sécurité > Cookies et données de sites</li>
                <li><strong>Safari :</strong> Préférences > Confidentialité > Cookies et données de sites web</li>
                <li><strong>Microsoft Edge :</strong> Paramètres > Cookies et autorisations de site > Cookies et données de sites</li>
              </ul>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Veuillez noter que si vous choisissez de bloquer ou de supprimer les cookies, certaines parties du Site peuvent ne pas fonctionner correctement ou peuvent ne pas être accessibles.
              </p>

              <h3 className="text-2xl font-bold mt-8 mb-4 text-white">
                Outils de Gestion des Cookies
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Vous pouvez également utiliser des outils en ligne pour gérer les cookies, tels que :
              </p>
              <ul className="list-disc list-inside space-y-3 text-gray-300 mb-6 ml-4">
                <li>Le site Your Online Choices (www.youronlinechoices.eu) pour gérer les cookies de publicité comportementale</li>
                <li>Les paramètres de votre compte Google pour gérer les cookies Google Analytics</li>
                <li>Les extensions de navigateur qui bloquent les cookies tiers</li>
              </ul>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                6. Cookies et Données Personnelles
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Certains cookies peuvent collecter des informations qui sont considérées comme des données personnelles. Pour plus d'informations sur la façon dont nous traitons vos données personnelles, veuillez consulter notre Politique de Confidentialité.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                7. Modifications de Cette Politique
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Nous pouvons mettre à jour cette Politique des Cookies de temps à autre pour refléter les changements dans les cookies que nous utilisons ou pour d'autres raisons opérationnelles, légales ou réglementaires. Nous vous informerons de tout changement significatif en publiant la nouvelle politique sur cette page.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                8. Contact
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Pour toute question concernant notre utilisation des cookies, contactez-nous :
              </p>
              <div className="bg-toxic-green/10 border border-toxic-green/30 rounded-xl p-6 mt-6">
                <p className="text-gray-300 mb-2"><strong>Email :</strong> info@hexabetconnect.com</p>
                <p className="text-gray-300 mb-2"><strong>Téléphone :</strong> +33 4 21 73 98 33</p>
                <p className="text-gray-300"><strong>Adresse :</strong> Paris, France</p>
              </div>
            </div>
          </article>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Cookies;

